import React from 'react';
import { StyleSheet, View } from 'react-native';

import SelectedParts from '../types/SelectedParts';
import isSafari from '../utils/isSafari';
import PFPPreview from './PFPPreview';

type Props = {
  selectedParts: SelectedParts;
};

const DOWNLOADED_IMAGE_SIZE = isSafari() ? 1600 : 800;

export default React.forwardRef(({ selectedParts }: Props, ref) => (
  <View style={styles.container}>
    <PFPPreview ref={ref} selectedParts={selectedParts} key="abc" />
  </View>
));

const styles = StyleSheet.create({
  container: {
    width: DOWNLOADED_IMAGE_SIZE,
    position: 'absolute',
    top: -4000,
  },
});
